module.exports = __webpack_public_path__ + "img/yishushengzhuce1.740f20a9.png";